import styled from 'styled-components';

export const SHeader = styled.header`
  display: flex;
  position: relative;
  justify-content: center;
  align-items: flex-start;
  height: var(--header-height);
  z-index: 1;

  [data-box='toasts'] {
    display: none;
    z-index: 100;
  }

  @media (max-width: 990px) and (max-aspect-ratio: 1/1) {
    [data-box='informer'] {
      display: flex;
    }

    [data-box='toasts'] {
      display: block;
      margin: 55px 0 0 8px;
    }
  }

  @media (max-width: 450px) and (max-aspect-ratio: 1/1) {
    [data-box='toasts'] {
      margin: 35px 0 0 2px;
    }
  }
`;
